import { create } from 'zustand';
import { defaultRoutes } from '../utils/menuUtils';

interface TabStore {
  tabs: { [path: string]: string };
  setTab: (path: string, childPath: string) => void;
  resetTabs: () => void;
}

const useTabStore = create<TabStore>((set) => ({
  tabs: defaultRoutes,
  setTab: (path: string, childPath: string) =>
    set((state) => ({
      tabs: {
        ...state.tabs,
        [path]: childPath,
      },
    })),
  resetTabs: () => set({ tabs: defaultRoutes }),
}));

export default useTabStore;
